import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=264a15a8&scoped=true&"
import script from "./NewTask.vue?vue&type=script&lang=js&"
export * from "./NewTask.vue?vue&type=script&lang=js&"
import style0 from "./NewTask.vue?vue&type=style&index=0&id=264a15a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a15a8",
  null
  
)

export default component.exports